module.exports = __webpack_public_path__ + "img/CM-SS-25-Mazda-Established.173d08f0.jpg";